<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="cars"
      :search="searchField"
      :loading="loading"
      hide-default-footer
      class="elevation-1"
    >
      <template #progress>
        <v-progress-linear color="red" indeterminate />
      </template>
      <template #items="props">
        <tr
          :class="{ tableRowColorSelected: props.index == activeRow }"
          class="tableRowColor"
          @click="activeRow = props.index"
        >
          <td class="text-xs">
            {{ props.item.title }}
          </td>
          <td class="text-xs">
            {{ props.item.model }}
          </td>
          <td class="text-xs">
            {{ props.item.type }}
          </td>
          <td class="text-xs">
            {{ props.item.year }}
          </td>
          <td class="text-xs">
            {{ props.item.brand }}
          </td>
          <!-- <td class="text-xs">{{ props.item.logo }}</td> -->
          <!--<td><img :src="'../assets/'+props.item.logo+'-logo.png'" height=35 width=35></td>-->
          <td>
            <img :src="getLogo(props.item.logo)" height="35" width="35" />
          </td>

          <td
            v-if="
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'LekoEmployee' ||
              $store.getters.role == 'SuperAdmin'
            "
            class="justify-center"
          >
            <v-row row>
              <v-icon class="mr-2 pointer" @click="editCar(props.item)">
                edit
              </v-icon>
              <v-icon class="pointer" @click="deleteCar(props.item._id)">
                delete
              </v-icon>
            </v-row>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogDelete" width="auto">
      <v-card>
        <v-card-title class="text-h6">
          <v-alert class="mb-0" :value="true" type="error">
            {{ $t("delete_alert") }}
          </v-alert>
        </v-card-title>

        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogDelete = false">
            {{ $t("close") }}
          </v-btn>
          <v-btn color="red" variant="outlined" @click="confirmDelete()">
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import getRequest from "../../api/getRequest";
import deleteRequest from "../../api/deleteRequest";

export default {
  data: () => ({
    loading: false,
    activeRow: null,
    searchField: "",
    headers: [
      {
        text: "",
        sortable: false,
        value: "title",
      },
      {
        text: "",
        sortable: false,
        value: "model",
      },
      {
        text: "",
        sortable: false,
        value: "type",
      },
      {
        text: "",
        sortable: false,
        value: "year",
      },
      {
        text: "",
        sortable: false,
        value: "brand",
      },
      {
        text: "",
        sortable: false,
        value: "logo",
      },
      {
        text: "",
        sortable: false,
      },
    ],
    cars: [],
    dialogDelete: false,
    carToDelete: null,
  }),
  created() {
    this.getLocale();
    this.getCars();
  },
  methods: {
    getLocale() {
      this.headers[0].text = this.$t("cars.table.title");
      this.headers[1].text = this.$t("cars.table.model");
      this.headers[2].text = this.$t("cars.table.type");
      this.headers[3].text = this.$t("cars.table.year");
      this.headers[4].text = this.$t("cars.table.brand");
      this.headers[5].text = this.$t("cars.table.logo");
      this.headers[6].text = this.$t("cars.table.actions");
    },
    getLogo(logo) {
      const img = require.context("../../assets/carLogos", false, /\.png$/);
      return img(`./${logo}-logo.png`);
    },
    search(value) {
      this.searchField = value;
    },
    getCars() {
      this.loading = true;
      getRequest("/car/")
        .then((response) => {
          this.cars = response.cars;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    editCar(car) {
      this.$emit("edit", car);
    },
    deleteCar(id) {
      this.carToDelete = id;
      this.dialogDelete = true;
    },
    confirmDelete() {
      this.loading = true;
      deleteRequest("/car/", `id=${this.carToDelete}`)
        .then(() => {})
        .catch(() => {})
        .finally(() => {
          this.loading = false;
          this.dialogDelete = false;
          this.carToDelete = null;
          this.getCars();
        });
    },
  },
};
</script>
